
import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { GatsbyImage, getImage } from "gatsby-plugin-image"



// interface AuthorProps {
//     html: string,
//     frontmatter: {
//         name: string;
//         id: string;
//         coverImage?: {
//             childImageSharp: {
//                 gatsbyImageData: {

//                 }
//             }
//         }
//     }
// }

export default function Author({ author }) {
    const image = getImage(author.frontmatter.coverImage);

    return (
        <Grid container sx={{marginBottom: 1 }}>
            <Grid item xs={1}>
                {image ? <Avatar 
                    sx={{ width: '100%', height: 'auto' }}
                    alt={author.frontmatter.name} 
                    src={image.images.fallback.src}
                />: <span/>}

            </Grid>
            <Grid item xs={11} sx={{ paddingLeft: '10px' }}>
                <Typography variant="subtitle2" component="h3" gutterBottom>
                  <b>By {author.frontmatter.name}</b>
                </Typography>
                <Typography 
                    variant="body2" 
                    component="p" 
                    gutterBottom
                    dangerouslySetInnerHTML={{__html: author.frontmatter.bylinebio}}
                />
            </Grid>
        </Grid>
    );
}